import React from 'react';
import { Box, Stack } from '@mui/material';
import Skeleton from '@/components/@IntranetLibrary/Skeleton';

const ApprovalContentsLoading = () => {
  return (
    <>
      {Array.from({ length: 12 }, (_, i) => i).map((item) => (
        <Stack key={item} gap={'16px'}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              padding: '10px',
              borderBottom: '1px solid var(--dk-line, #f0f0f0)',
              gap: '20px',
            }}
          >
            <Stack sx={{ flex: 1.5, gap: '4px' }}>
              <Skeleton width={'10%'} />
              <Skeleton width={'100%'} />
              <Skeleton width={'90%'} />
              <Skeleton width={'50%'} />
            </Stack>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                flex: 1,
                gap: '10px',
                alignItems: 'center',
              }}
            >
              <div>
                <Skeleton variant={'circle'} width={'32px'} height={'32px'} />
              </div>
              <Stack sx={{ gap: '4px', width: '100%' }}>
                <Skeleton width={'50%'} />
                <Skeleton />
                <Skeleton width={'80%'} />
              </Stack>
            </Box>
          </Box>
        </Stack>
      ))}
    </>
  );
};

export default ApprovalContentsLoading;
